import { useRouter } from "expo-router";
import { useSetAtom } from "jotai/react";
import { LockIcon } from "lucide-react-native";

import { FullLogo } from "@/blocks/FullLogo";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { isSessionExpiredAtom } from "@/stores/atoms";

export const SessionTimedOutScreen = () => {
  const router = useRouter();
  const setIsSessionExpired = useSetAtom(isSessionExpiredAtom);

  return (
    <VnBox className="bg-background flex min-h-screen w-full items-center justify-center">
      <VnBox className="-mt-6 flex w-full max-w-sm flex-col items-center gap-6 px-6">
        <FullLogo className="w-48" />
        <VnBox className="bg-card border-border flex w-full flex-col items-center gap-4 rounded-lg border p-6">
          <VnBox className="bg-sidebar/10 flex size-16 items-center justify-center rounded-full">
            <VnIcon as={LockIcon} className="text-sidebar" size={32} />
          </VnBox>
          <VnText
            variant="headerOne"
            className="text-center"
            i18nKey="native:sessionTimedOut.title"
          />
          <VnText
            variant="md"
            className="text-muted-foreground text-center"
            i18nKey="native:sessionTimedOut.description"
          />
          <VnButton
            className="mt-2 w-full"
            onPress={() => {
              setIsSessionExpired(false);
              router.replace("/(unauthed)/auth");
            }}
            i18nKey="native:sessionTimedOut.loginAgain"
          />
        </VnBox>
      </VnBox>
    </VnBox>
  );
};
